import(/* webpackMode: "eager" */ "/home/interim/frontend/app/solutions/page.tsx");
